import { debug } from "aaa";
import { getCurrentSigningStore } from "components/signing/stores/SigningStore";

export function georgeAppDidBecomeActive() {
    debug.log("### georgeAppDidBecomeActive");
    const store = getCurrentSigningStore();
    if (!store) {
        return;
    }

    store.georgeAppDidBecomeActive();
}

export function georgeAppDidEnterBackground() {
    debug.log("### georgeAppDidEnterBackground");
    const store = getCurrentSigningStore();
    if (!store) {
        return;
    }

    // Not really necessary. Only comment in if restart only doesn't work.
    store.georgeAppDidEnterBackground();
}


// WEBPACK FOOTER //
// ./src/util/georgeCallbacks.ts